import { Tooltip } from '@chakra-ui/react';
import * as React from 'react';

import { HelpCircleIcon } from '../chakra/feather';

export const InfoPopup: React.FC<{
  info: string;
  iconColor?: string;
}> = ({ info, iconColor }) => {
  return (
    <>
      {!!info && (
        <Tooltip
          label={info}
          placement="top"
          hasArrow
          fontSize="md"
          py="2"
          px="4"
        >
          <HelpCircleIcon color={iconColor ?? 'gray.400'} ml="1" />
        </Tooltip>
      )}
    </>
  );
};
